import { useHistory } from 'react-router-dom'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewMessage } from './PreviewMessage'

import { isProduction } from '../../settings.js'
import { PreviewBankwire } from './PreviewBankwire/PreviewBankwire'
import { PreviewInstructions } from './PreviewInstructions'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'
import { useEventTracker } from 'mmfintech-checkout-commons'

export const DepositResult = ({ response, session, sessionId }) => {
  const { result, resultType, status, processingAmount, processingCurrency } = response || {}

  const history = useHistory()

  const { trackEvent } = useEventTracker()

  if (status === 'FAILED') {
    history.push('/fail')
    return
  }
  if (status === 'PROCESSED') {
    history.push('/success')
  }

  const redirectToProvider = () => {
    trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
  }

  switch (resultType) {
    // case 'INTERNAL_EXECUTION':
    // case 'CRYPTO_ADDRESS_DETAILS':
    // case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':

    case 'INSTRUCTIONS':
      return <PreviewInstructions result={{ ...result, processingAmount, processingCurrency }} sessionId={sessionId} />

    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'BANKWIRE_DETAILS':
      return <PreviewBankwire result={result} session={session} sessionId={sessionId} />

    case 'REDIRECT_URL':
      redirectToProvider()
      break

    case 'QR_CODE':
      return <PreviewPix value={result} />

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame result={result} />
      }
      break

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unsupported result type "${resultType}"`)
      }
  }

  return null
}
